<template>
  <div>
    <Modal v-model="show" title="锁定屏幕" footer-hide width="400">
      <Form :label-width="90" label-colon>
        <FormItem :required="true" label="锁屏密码">
          <Input v-model="modal_password" placeholder="请输入锁屏密码"></Input>
        </FormItem>
      </Form>
      <Button type="info" long @click="lock">锁定</Button>
    </Modal>
    <div class="lock-screen" v-if="lock_show">
      <div class="screen-unlock" @click="unlock_show = true" v-show="!unlock_show">
        <span class="iconfont icon-suoding1"></span>
        <span>点击解锁</span>
      </div>
      <div class="screen-time">
        <div style="position: relative; margin-right: 80px;">
          <span>{{ date.h }}</span>
          <span class="time-zone" v-show="!unlock_show">{{ date.n }}</span>
        </div>
        <div>
          <span>{{ date.i }}</span>
        </div>
      </div>
      <div class="screen-date">
        <div class="date-time enter-x" v-show="unlock_show">{{ date.h }}:{{ date.i }} <span
            style="font-size: 30px; line-height: 36px;">{{ date.n }}</span></div>
        <div class="date-text">{{ date.y }}/{{ date.m }}/{{ date.d }} {{ date.w }}</div>
      </div>
      <div class="screen-entry" v-show="unlock_show">
        <div class="entry-content">
          <div class="content-header enter-x">
            <div class="header-img"><img src="" alt=""></div>
            <div class="header-name">{{ userInfo ? userInfo.uname : 'admin' }}</div>
          </div>
          <Input v-model="password" placeholder="请输入锁屏密码" password type="password" class="enter-x"></Input>
          <div class="error-msg enter-x" v-if="error_show">锁屏密码错误</div>
          <div class="content-footer">
            <div class="enter-x" @click="unlock_show = false">返回</div>
            <div class="enter-x" @click="back_login()">返回登录</div>
            <div class="enter-x" @click="enter_system()">进入系统</div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import md5 from 'js-md5'
  export default {
    name: 'LockScreen',
    data() {
      return {
        userInfo: JSON.parse(localStorage.getItem('userInfo')),
        modal_password: '',
        password: '',
        show: false,
        lock_show: false,
        unlock_show: false,
        error_show: false,
        timer: null,
        date: {
          y: '',
          m: '',
          d: '',
          n: 'AM',
          h: '',
          i: '',
          s: ''
        }
      }
    },
    created() {
      var _this = this;
      // console.log('lock_screen');
      if (localStorage.getItem('lock_screen_password')) {
        this.lock_show = true;
        if (!this.timer) {
          this.create_date();
          this.timer = setInterval(() => {
            _this.create_date();
          }, 1000);
        }
      }
    },
    methods: {
      open() {
        this.show = true;
        this.modal_password = '';
      },
      // 锁定屏幕
      lock() {
        var _this = this;
        if (!this.modal_password) {
          return this.alertErr('请输入锁屏密码');
        }
        this.show = false;
        this.lock_show = true;
        localStorage.setItem('lock_screen_password', md5(this.modal_password).substr(2, 28));
        this.create_date();
        this.timer = setInterval(() => {
          _this.create_date();
        }, 1000);
      },
      // 创建时间
      create_date() {
        var date = new Date();
        this.date.y = date.getFullYear();
        this.date.m = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
        this.date.d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        this.date.h = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
        if (this.date.h > 12) {
          this.date.n = 'PM';
        } else {
          this.date.n = 'AM';
        }
        this.date.i = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
        this.date.s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
        var weekday = date.getDay();
        var arr = new Array('星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六');
        this.date.w = arr[weekday];
      },
      back_login() {
        this.$emit('on-change');
      },
      enter_system() {
        let pwd = md5(this.password).substr(2, 28);
        if (pwd == localStorage.getItem('lock_screen_password')) {
          this.lock_show = false;
          localStorage.removeItem('lock_screen_password');
          clearInterval(this.timer);
        } else {
          this.error_show = true;
        }
      }
    }
  }
</script>

<style scoped>
  .lock-screen {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    background: #000000;
  }

  .screen-unlock {
    position: absolute;
    top: 0;
    left: 50%;
    padding-top: 20px;
    height: 64px;
    line-height: 28px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #ffffff;
    font-size: 20px;
    transform: translate(-50%);
    cursor: pointer;
  }

  .screen-time {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .screen-time>div {
    display: flex;
    font-weight: 700;
    color: #bababa;
    background-color: #141313;
    border-radius: 30px;
    justify-content: center;
    align-items: center;
    height: 80%;
    width: 40%;
    font-size: 260px;
  }

  .screen-time .time-zone {
    position: absolute;
    left: 20px;
    top: 20px;
    font-size: 20px;
    line-height: 28px;
  }

  .screen-date {
    position: absolute;
    bottom: 20px;
    width: 100%;
    font-size: 20px;
    line-height: 28px;
    text-align: center;
    color: rgb(209, 213, 219);
    z-index: 9;
  }

  .screen-date .date-time {
    margin-bottom: 16px;
    font-size: 48px;
    line-height: 48px;
  }

  .screen-date .date-text {
    font-size: 24px;
    line-height: 32px;
  }

  .screen-entry {
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    width: 100%;
    height: 100%;
    background-color: #00000080;
    backdrop-filter: blur(8px);
    justify-content: center;
    align-items: center;
  }

  .screen-entry .entry-content {
    width: 260px;
  }

  .entry-content .content-header {
    text-align: center;
    margin-bottom: 16px;
    font-size: 14px;
  }

  .entry-content .content-header .header-img {
    width: 70px;
    margin: 0 auto;
    border-radius: 50%;
  }

  .entry-content .content-header .header-name {
    margin-top: 5px;
    font-weight: 500;
    color: #bababa;
  }

  .entry-content .content-footer {
    display: flex;
    justify-content: space-between;
  }

  .entry-content .content-footer>div {
    margin-top: 8px;
    padding: 0 8px;
    color: #409eff;
    cursor: pointer;
  }

  .entry-content .content-footer>div:hover {
    color: #69b9ff;
  }

  .enter-x {
    transform: translate(50px);
    z-index: 9;
    opacity: 0;
    animation: enter-x-animation .4s ease-in-out .3s;
    animation-fill-mode: forwards;
    animation-delay: .1s;
  }

  .entry-content .error-msg {
    display: inline-block;
    margin-top: 10px;
    color: #ed6f6f;
  }

  @keyframes enter-x-animation {
    to {
      opacity: 1;
      transform: translate(0);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/adm/user/lock_screen.vue